import { createActionConst } from '../../../utils/action.utils';

const TASK_NAMESPACE = 'TASK';

export const STORE_TASK = createActionConst(TASK_NAMESPACE, 'STORE_TASK');
export const CLEAR_TASK = createActionConst(TASK_NAMESPACE, 'CLEAR_TASK');
